const fragment = `
  id
  isDefault
  package {
    id
    name
    imageUrl
  }
`;

export const listProjectPackagesQuery = `
  query ListProjectPackages(
    $filter: ProjectPackageFilterInput
  ) {
    items: listProjectPackages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createProjectPackageQuery = `
  mutation CreateProjectPackage(
    $input: CreateProjectPackageInput!
  ) {
    item: createProjectPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const updateProjectPackageQuery = `
  mutation UpdateProjectPackage(
    $input: UpdateProjectPackageInput!
  ) {
    item: updateProjectPackage(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteProjectPackageQuery = `
  mutation DeleteProjectPackage(
    $id: Int!
  ) {
    item: deleteProjectPackage(id: $id) {
      ${fragment}
    }
  }
`;
